import { UserInfo } from '../types';

/**
 * Percorso della dashboard tecnica per l'utente corrente. Per FINANCE la home '/' e' la lista
 * fatturazione, quindi la dashboard tecnica vive su '/dashboard'; per tutti gli altri ruoli e' '/'.
 */
export const getDashboardPath = (user: UserInfo | null | undefined): string =>
  user?.role === 'FINANCE' ? '/dashboard' : '/';
